export const environment = {
  production: false,
  apiUrl: 'https://api-dev.joyinvoice.com/api/v1',
  appName: 'Joy Invoice',
  version: '1.0.0',
};
